<template>
    <transition name="accordion">
        <ul
            class="cielo-dropdown"
            v-show="isOptionsOpen"
            @click.stop.self
            @keyup.esc="isOptionsOpen ? $emit('close-dropdown') : null"
            ref="cieloDropdown"
        >
            <slot />
        </ul>
    </transition>
</template>

<script>
    export default {
        props: {
            isOptionsOpen: {
              type: Boolean
            }
        },
        watch: {
            isOptionsOpen(value) {
                if(value) {
                    let element = this.$refs.cieloDropdown;

                    element.focus();
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .cielo-dropdown {
        position: absolute;
        top: 48px;
        left: 0;
        width: 100%;
        padding: 0;
        z-index: 4;
        overflow: auto;
        background-color: white;
        list-style: none;
        border: 1px solid #0774E7;
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
        transition: all .3s ease-in-out;

		@media screen and (min-width: 1025px) {
              max-height: 250px;
          }

          @media screen and (min-width: 1366px) {
              max-height: 410px;
          }

        &:focus-visible {
           outline: none;
        }


    }

	.accordion-enter-active {
        transition: max-height 0.5s ease-in-out, padding 0.5s ease-in-out, opacity 0.5s ease-in-out;
        opacity: 1;
    }
    .accordion-leave-active {
        transition: max-height 0.5s ease-in-out, padding 0.5s ease-in-out, opacity 0.5s ease-in-out;
        opacity: 0;
    }
    .accordion-enter, .accordion-leave-to {
        max-height: 0;
    }

</style>
